@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.error-modal {
  width: 350px;
  border-top: 5px solid @error-modal--border-color;
  border-radius: 0 0 5px 5px;

  &.warning {
    border-top: 5px solid @error-modal--warning--border-color;

    .title-text {
      color: @error-modal--warning--text-color;
    }
  }

  &.info {
    border-top: 5px solid @error-modal--info--border-color;

    .title-text {
      color: @error-modal--info--text-color;
    }
  }

  .footer-button {
    margin-left: 10px;
  }
}

.error-modal-body {
  padding: 15px;
}

.title-row {
  display: flex;
}

.state-icon-wrapper {
  width: 40px;
  min-width: 40px;
  height: 40px;
}

.title-text {
  .truncate();
  line-height: 40px;
  font-size: 20px;
  color: @error-modal--title--text-color;
  width: 100%;
  max-width: 100%;
  padding: 0 10px;
}

.close-button-wrapper {
  width: 30px;
  height: 40px;
  min-width: 30px;
}

.message {
  margin-top: 15px;
  font-size: 14px;
  color: @error-modal--message--text-color;
}
